import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  User, 
  Bell, 
  Shield, 
  Globe, 
  Database,
  Zap,
  Eye,
  Save,
  RefreshCw
} from 'lucide-react';

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('profile');

  const tabs = [
    { id: 'profile', name: 'الملف الشخصي', icon: User },
    { id: 'notifications', name: 'الإشعارات', icon: Bell },
    { id: 'security', name: 'الأمان', icon: Shield },
    { id: 'system', name: 'النظام', icon: Database },
    { id: 'processing', name: 'المعالجة', icon: Zap },
    { id: 'appearance', name: 'المظهر', icon: Eye },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="form-group">
                <label className="form-label">الاسم الكامل</label>
                <input type="text" className="input" defaultValue="أحمد محمد" />
              </div>
              <div className="form-group">
                <label className="form-label">البريد الإلكتروني</label>
                <input type="email" className="input" defaultValue="ahmed@example.com" />
              </div>
              <div className="form-group">
                <label className="form-label">المنصب</label>
                <input type="text" className="input" defaultValue="مدير المحتوى" />
              </div>
              <div className="form-group">
                <label className="form-label">رقم الهاتف</label>
                <input type="tel" className="input" defaultValue="+966501234567" />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">الصورة الشخصية</label>
              <div className="flex items-center space-x-4 space-x-reverse">
                <div className="w-16 h-16 bg-gradient-primary rounded-full flex items-center justify-center">
                  <User className="w-8 h-8 text-white" />
                </div>
                <div>
                  <button className="btn-outline btn-sm">تغيير الصورة</button>
                  <p className="text-xs text-gray-500 mt-1">JPG, PNG حتى 2MB</p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'notifications':
        return (
          <div className="space-y-6">
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h4 className="font-medium text-gray-900">إشعارات المعالجة</h4>
                  <p className="text-sm text-gray-600">تلقي إشعارات عند اكتمال معالجة العروض</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" defaultChecked />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
                </label>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h4 className="font-medium text-gray-900">إشعارات الأخطاء</h4>
                  <p className="text-sm text-gray-600">تلقي إشعارات عند حدوث أخطاء في المعالجة</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" defaultChecked />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
                </label>
              </div>

              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h4 className="font-medium text-gray-900">إشعارات الأداء</h4>
                  <p className="text-sm text-gray-600">تلقي تقارير أسبوعية عن أداء النظام</p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input type="checkbox" className="sr-only peer" />
                  <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
                </label>
              </div>
            </div>
          </div>
        );

      case 'security':
        return (
          <div className="space-y-6">
            <div className="form-group">
              <label className="form-label">كلمة المرور الحالية</label>
              <input type="password" className="input" />
            </div>
            <div className="form-group">
              <label className="form-label">كلمة المرور الجديدة</label>
              <input type="password" className="input" />
            </div>
            <div className="form-group">
              <label className="form-label">تأكيد كلمة المرور</label>
              <input type="password" className="input" />
            </div>
            <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <h4 className="font-medium text-blue-900 mb-2">متطلبات كلمة المرور:</h4>
              <ul className="text-sm text-blue-800 space-y-1">
                <li>• 8 أحرف على الأقل</li>
                <li>• حرف كبير واحد على الأقل</li>
                <li>• حرف صغير واحد على الأقل</li>
                <li>• رقم واحد على الأقل</li>
                <li>• رمز خاص واحد على الأقل</li>
              </ul>
            </div>
          </div>
        );

      case 'system':
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="form-group">
                <label className="form-label">اللغة الافتراضية</label>
                <select className="input">
                  <option value="ar">العربية</option>
                  <option value="en">English</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">المنطقة الزمنية</label>
                <select className="input">
                  <option value="Asia/Riyadh">الرياض (GMT+3)</option>
                  <option value="Asia/Dubai">دبي (GMT+4)</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">مسار حفظ الملفات</label>
              <input type="text" className="input" defaultValue="/uploads/offers/" />
            </div>
            <div className="form-group">
              <label className="form-label">الحد الأقصى لحجم الملف (MB)</label>
              <input type="number" className="input" defaultValue="50" />
            </div>
          </div>
        );

      case 'processing':
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="form-group">
                <label className="form-label">مستوى الثقة الأدنى</label>
                <input type="number" className="input" defaultValue="0.7" step="0.1" min="0" max="1" />
                <p className="form-help">المنتجات بثقة أقل من هذا المستوى تحتاج مراجعة</p>
              </div>
              <div className="form-group">
                <label className="form-label">عدد المحاولات لإعادة المعالجة</label>
                <input type="number" className="input" defaultValue="3" min="1" max="10" />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">مفتاح Gemini API</label>
              <input type="password" className="input" defaultValue="••••••••••••••••" />
            </div>
            <div className="form-group">
              <label className="form-label">مسار نموذج YOLO</label>
              <input type="text" className="input" defaultValue="models/best.pt" />
            </div>
            <div className="flex items-center space-x-3 space-x-reverse">
              <button className="btn-outline">
                <RefreshCw className="w-4 h-4 ml-2" />
                اختبار الاتصال
              </button>
              <span className="text-sm text-success-600">✓ الاتصال سليم</span>
            </div>
          </div>
        );

      case 'appearance':
        return (
          <div className="space-y-6">
            <div className="form-group">
              <label className="form-label">المظهر</label>
              <div className="space-y-2">
                <label className="flex items-center space-x-2 space-x-reverse">
                  <input type="radio" name="theme" value="light" className="text-primary-600" defaultChecked />
                  <span>فاتح</span>
                </label>
                <label className="flex items-center space-x-2 space-x-reverse">
                  <input type="radio" name="theme" value="dark" className="text-primary-600" />
                  <span>داكن</span>
                </label>
                <label className="flex items-center space-x-2 space-x-reverse">
                  <input type="radio" name="theme" value="system" className="text-primary-600" />
                  <span>حسب النظام</span>
                </label>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">اللون الأساسي</label>
              <div className="flex items-center space-x-3 space-x-reverse">
                <div className="w-10 h-10 bg-blue-500 rounded-full border-2 border-blue-600"></div>
                <div className="w-10 h-10 bg-green-500 rounded-full border-2 border-gray-300"></div>
                <div className="w-10 h-10 bg-purple-500 rounded-full border-2 border-gray-300"></div>
                <div className="w-10 h-10 bg-red-500 rounded-full border-2 border-gray-300"></div>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">حجم الخط</label>
              <select className="input">
                <option value="sm">صغير</option>
                <option value="md" selected>متوسط</option>
                <option value="lg">كبير</option>
              </select>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">الإعدادات</h1>
        <p className="text-gray-600">
          إدارة إعدادات النظام والملف الشخصي
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Sidebar */}
        <div className="lg:col-span-1">
          <div className="card">
            <div className="card-body p-0">
              <nav className="space-y-1">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`w-full flex items-center space-x-3 space-x-reverse px-4 py-3 text-right transition-colors ${
                      activeTab === tab.id
                        ? 'bg-primary-50 text-primary-700 border-r-2 border-primary-600'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    <tab.icon className="w-5 h-5" />
                    <span className="font-medium">{tab.name}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="lg:col-span-3">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3 }}
            className="card"
          >
            <div className="card-header">
              <h3 className="font-semibold text-gray-900">
                {tabs.find(tab => tab.id === activeTab)?.name}
              </h3>
            </div>
            <div className="card-body">
              {renderTabContent()}
              
              {/* Save Button */}
              <div className="flex justify-end pt-6 border-t border-gray-200">
                <button className="btn-primary">
                  <Save className="w-4 h-4 ml-2" />
                  حفظ التغييرات
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Settings;